if (!customElements.get('rm-collapsible')) {
    customElements.define('rm-collapsible', class RMCollapsible extends HTMLElement {
        constructor() {
            super();
            this.element = this.querySelector('[rm-collapsible]');
            this.target = document.querySelector(this.element.getAttribute("target"));
            this.action = this.element.getAttribute('data-action');
            this.lock_scroll = this.element.getAttribute('data-no-scroll');
            this.sibling_buttons = this.element.getAttribute('button-set');
            this.no_children = this.element.getAttribute('fixed-listener')
            this.addEventListener('click', this.clickAction);
        }

        clickAction(event) {
            if (this.no_children != undefined) {
                if (this.element != event.target) return
            }
            if (this.action == "toggle") {
               this.toggle();
            }

            if (this.action == "open") {
                this.open();
            }

            if (this.action == "close") {
                this.close();
            }
        }

        open() {
            this.target.setAttribute('aria-hidden', false);
            this.element.setAttribute('aria-expanded', true);

            if (this.lock_scroll != undefined)  {
                document.querySelector('html').classList.add('no-scroll');
            }

            if (this.sibling_buttons != undefined) {
                let sibling_buttons = document.querySelectorAll(`rm-collapsible [data-action=open][button-set=${this.sibling_buttons}]`);
                let _this = this;
                sibling_buttons.forEach(function(button) {
                    if (button != _this && button != _this.element) {
                        let target = document.querySelector(button.getAttribute('target'));
                        button.setAttribute('aria-expanded', false);
                        target.setAttribute('aria-hidden', true);
                    } 
                })
            }
        }

        close() {
            this.target.setAttribute('aria-hidden', true);
            this.element.setAttribute('aria-expanded', false);

            if (this.lock_scroll != undefined)  {
                document.querySelector('html').classList.remove('no-scroll');
            }
        }

        toggle() {
            let getState = this.target.getAttribute('aria-expanded');
            let setState;
            if (getState == "false") {
                setState = true;
                this.element.setAttribute('aria-expanded', setState);
                this.target.setAttribute('aria-hidden',  false);

                if (this.lock_scroll != undefined)  {
                    document.querySelector('html').classList.add('no-scroll');
                }
            } else {
                setState = false;
                this.element.setAttribute('aria-expanded', setState);
                this.target.setAttribute('aria-hidden',  true);

                if (this.lock_scroll != undefined)  {
                    document.querySelector('html').classList.remove('no-scroll');
                }
            }

            if (this.sibling_buttons != undefined) {
                let sibling_buttons = document.querySelectorAll('rm-collapsible [data-action=toggle]');
                let _this = this;
                sibling_buttons.forEach(function(button) {
                    if (button != _this && button != _this.element) {
                        button.setAttribute('aria-expanded', setState);
                    } 
                })
            }
        }
    })
}